import React, { forwardRef } from "react";
import P from "../P/P";
import { TextAreaProps } from "./TextArea.props";

const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
	(
		{
			label,
			error,
			onChange,
			containerClassName = "",
			textAreaClassName = "",
			labelClassName = "",
			text = "black",
			rows = 5,
			cols = 3,
			...props
		},
		ref,
	) => {
		return (
			<div className={`flex flex-col gap-1 ${containerClassName}`}>
				{label && (
					<P
						size="t1"
						type="regular"
						className={`text-${text} ${labelClassName}`}
					>
						{label}
					</P>
				)}

				<textarea
					ref={ref}
					onChange={onChange}
					className={`input border text-light-textColor border-stroke rounded-lg py-2 px-4 focus:outline-none transition-all duration-300 text-t1 font-normal ease-in-out hover:border-shadeOne focus:border-shadeOne focus:ring-0 focus:ring-transparent resize-none ${
						textAreaClassName
					} ${error ? "border-red-500 focus:ring-red-500" : ""}`}
					{...props}
					rows={rows}
					cols={cols}
				/>

				{error && <p className="mt-1 text-sm text-red-500">{error}</p>}
			</div>
		);
	},
);

export default React.memo(TextArea);
